module.exports = __webpack_public_path__ + "img/album23_17.06ac6ddb.jpg";